<template>
  <v-form ref="createUpdateTextAreaForm" v-model="formValid" @submit.prevent v-if="existing">
    <v-list-item v-if="!formField">
      <v-list-item-content>
        <v-list-item-subtitle>{{ label }}</v-list-item-subtitle>
        {{ existing }}
      </v-list-item-content>
      <v-list-item-icon>
        <v-btn icon small @click="formField = true" title="Edit Field">
          <v-icon small color="warning" v-text="mdiPencilOutline" />
        </v-btn>
      </v-list-item-icon>
    </v-list-item>
    <v-list-item v-else>
      <v-list-item-content dense>
        <v-textarea
          v-model="newTextValue"
          :label="`Edit ${label}`"
          :rules="rules"
          filled
          counter
          maxlength="512"
          color="dw_green"
        ></v-textarea>
        <div class="d-flex pt-1">
          <v-btn
            type="button"
            @click="resetField"
            outlined
            x-small
            color="red">
            <v-icon x-small color="red" class="mr-1" v-text="mdiClose" />
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            type="button"
            :disabled="newTextValue === existing || !formValid"
            @click="updateField"
            outlined
            x-small
            color="primary">
            <v-icon x-small color="primary" class="mr-1" v-text="mdiCheck" />
            Done
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-form>
</template>

<script>
import { mdiCheck, mdiPencilOutline, mdiClose } from '@mdi/js';
import { mapActions } from 'vuex';
import utils from '@/utils/index';

export default {
  name: 'formTextArea',
  props: ['existing', 'label', 'isRequired'],
  data() {
    return {
      mdiCheck,
      mdiPencilOutline,
      mdiClose,
      formField: false,
      formValid: false,
      newTextValue: ''
    }
  },
  watch: {
    formField() {
      if (this.formField) this.newTextValue = this.existing;
    }
  },
  computed: {
    rules() {
      let validRules = [
        utils.validationRules.min,
        utils.validationRules.descMax,
        utils.validationRules.textRegex
      ];
      if (this.isRequired) validRules = validRules.splice(0, 0, utils.validationRules.required);
      return validRules;
    }
  },
  methods: {
    updateField() {
      this.$emit('fieldChanged', this.newTextValue);
      this.formField = false;
    },
    resetField() {
      this.formField = false;
    }
  }
};
</script>
